import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { RWebShare } from 'react-web-share'

import Share from '../../images/svg/share.svg'
import {
  Breadcrumbs,
  H1Styled,
  Left,
  MetaContainer,
  MetaContainerWrapper,
  Right,
} from '../atoms/style-helpers'

type PageHeaderPropTypes = {
  data: {
    title: string
    slug: string
    categories: [
      {
        title: string
        slug: string
      },
    ]
    // heroImage: {
    //   title: string
    //   image: typeof GatsbyImage | typeof GatsbyImage[]
    // }
    startDate: string
    endDate: string
    leadingParagraph: {
      childMarkdownRemark: {
        rawMarkdownBody: string
      }
    }
    eventType: {
      title: string
      slug: string
    }
  }
  breadcrumbs: JSX.Element
  uppercase?: boolean
}

const PageHeader = (props: PageHeaderPropTypes): JSX.Element => {
  const { title, leadingParagraph, categories } = props.data
  const { breadcrumbs, uppercase } = props

  return (
    <>
      <MetaContainer>
        <Breadcrumbs>{breadcrumbs}</Breadcrumbs>
        <MetaContainerWrapper>
          <Left>
            <H1Styled>{title}</H1Styled>
            {categories?.map((category) => {
              if (category?.slug === 'stories') {
                return (
                  <RWebShare
                    key={category.slug}
                    data={{
                      text: title,
                      title: `Share "${title}"`,
                    }}
                    sites={[
                      'facebook',
                      'twitter',
                      'linkedin',
                      'whatsapp',
                      'mail',
                      'copy',
                    ]}
                  >
                    <Share />
                  </RWebShare>
                )
              }
              return ''
            })}
          </Left>
          {leadingParagraph?.childMarkdownRemark?.rawMarkdownBody && (
            <Right>
              {leadingParagraph.childMarkdownRemark.rawMarkdownBody}
            </Right>
          )}
        </MetaContainerWrapper>
      </MetaContainer>
    </>
  )
}

export default PageHeader
